import React, { Component } from 'react'
import { BrowserRouter as Router, HashRouter, Redirect } from "react-router-dom"
// import cover from './../../assets/img/cover/ProhaceWidth.jpeg'
import cover from './../../assets/img/cover/NagamasWidth.png'
// import cover from './../../assets/img/cover/test.png'
import LoadingBar from 'react-top-loading-bar'
import AuthAction from '../../Redux/AuthRedux'
import { connect } from 'react-redux';
import Modal from '../../modules/popup/Modal'
import FlexView from 'react-flexview'
import API from '../../Services/Api'
import { Rabbit as Button } from 'react-button-loaders'
import SimpleInput from "../../modules/SimpleInput";
import { checkResponseError } from '../../Services/Utils'
import OtpTimer from 'otp-timer'
import * as R from 'ramda'
import Logo from './../../assets/img/logo-prohace.png'
import OtpInput from 'react-otp-input';
const CryptoJS = require("crypto-js");

const defaultPayloadForgotPass = {
    "register": "",
    "registerType": "nik",
    "email": "",
    "companyGroupId": "",
    "idDevice": 'web-123',
}

class Login extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loginData: {
                register: 'restu',
                registerType: 'nik',
            },
            username: null,
            password: null,
            dealerGroupId: 'NOS',
            confirmPassword: '',
            redirect: !!props.auth.user,
            role: ['ROLE_SID_WEB_ADMIN'],
            modalVisible: false,
            modalVisibleStep2: false,
            modalVisibleStep3: false,
            modalSuccessVisible: false,
            forceCP: false,
            sendstate: '',
            payloadForgotPass: defaultPayloadForgotPass,
            typeNewPass: false,
            typeRePass: false,
            errMsg: false,
            forcedChangePassword: {
                modalVisible: false,
                payload: this.defaultChangePassword,
            },
        }

        this.handleChangeUsername = this.handleChangeUsername.bind(this)
        this.handleChangePassword = this.handleChangePassword.bind(this)
        this.handleChangeCompanyGroup = this.handleChangeCompanyGroup.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    defaultChangePassword = {
        oldPassword: "",
        confirmNewPassword: "",
        newPassword: "",
    };

    //--BEGIN------for forced change password---------------------

    hideModalChangePassword = () => {
        this.setState({
            forcedChangePassword: {
                ...this.state.forcedChangePassword,
                modalVisible: false,
            }
        });
        this.forceLogout();
    }
    showModalChangePassword = () => this.setState({
        forcedChangePassword: {
            ...this.state.forcedChangePassword,
            modalVisible: true,
            payload: {
                ...this.state.forcedChangePassword.payload,
                oldPassword: this.state.password
            }
        }
    })

    forceLogout = () => {
        localStorage.clear("name");
        localStorage.clear("token");
        localStorage.clear("persist:primary");

        this.props.authLogout();
    }

    handleFinishChangePassword = (payload) => {
        // console.log("--------FC-------");
        payload.oldPassword = this.state.password;
        // console.log(payload);

        if (R.isEmpty(payload.oldPassword)) return alert('Please Fill Old Password !')
        if (R.isEmpty(payload.newPassword)) return alert('Please Fill New Password !')
        if (!payload.newPassword.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,})$/)) return this.setState({ errMsg: true })
        if (this.state.errMsg) this.setState({ errMsg: false })
        if (R.isEmpty(payload.confirmNewPassword)) return alert('Please Fill Confirm Password !')
        if (payload.newPassword !== payload.confirmNewPassword) return alert('Please make sure your password match !')
        payload = {
            ...payload,
            oldPassword: CryptoJS.MD5(payload.oldPassword).toString(),
            newPassword: CryptoJS.MD5(payload.newPassword).toString()
        }
        this.startFetch();
        API.create("EKSAD")
            .postChangePass(payload)
            .then(res => {
                this.onFinishFetch();
                if (res.data && res.data.code === 201) {
                    let routes = "/home";
                    this.setState({ redirect: true, routes, });
                } else {
                    this.forceLogout();
                }
            });
    }

    //--END------for forced change password---------------------

    hideModalStep3 = () => this.setState({ modalVisibleStep3: false })

    statusSendState(type) {
        this.setState({ sendState: type, errMsg: false })
    }

    setUsername(e) {
        this.setState({ payloadForgotPass: { ...this.state.payloadForgotPass, register: e.target.value } });
    }

    setEmail(e) {
        this.setState({ payloadForgotPass: { ...this.state.payloadForgotPass, email: e.target.value } });
    }

    setGroupID(e) {
        this.setState({ payloadForgotPass: { ...this.state.payloadForgotPass, companyGroupId: e.target.value.toUpperCase() } });
    }

    setPassword(e) {
        this.setState({ payloadForgotPass: { ...this.state.payloadForgotPass, password: e.target.value } });
    }

    setConfirmPassword(e) {
        this.setState({ confirmPasswordValue: e.target.value });
    }

    showModal = () => this.setState({ modalVisible: true, email: '' })

    hideModal = () => this.setState({ modalVisible: false, payloadForgotPass: defaultPayloadForgotPass, forceCP: false })

    hideModalStep2 = () => this.setState({ modalVisibleStep2: false, forceCP: false })

    hideModalStep3 = () => this.setState({ modalVisibleStep3: false, forceCP: false })

    showPassword = type => {
        switch (type) {
            case "new":
                this.setState({ typeNewPass: !this.state.typeNewPass });
                break;
            case "confirm":
                this.setState({ typeRePass: !this.state.typeRePass });
                break;
            default:
                break;
        }
    };

    async _handleResend(payload) {
        this.startFetch()
        payload = {
            "register": payload.register,
            "registerType": "nik",
            "email": payload.email,
            "companyGroupId": payload.companyGroupId,
            "idDevice": "WEB-123",
        }
        let response = await API.create('API_USER_RESET').postForgotPass(payload)
        if (response.ok && response.data.status === "S") {
            this.onFinishFetch()
        } else {
            this.onFinishFetch()
            checkResponseError(response)
        }
    }

    handleReset = async (payload) => {
        this.statusSendState('loading')
        let res = await API.create("API_USER_RESET").postForgotPass(payload);
        if (res.ok && res.data.status === "S") {
            this.statusSendState('finished')
            setTimeout(() => {
                this.setState({
                    modalVisible: false,
                    modalVisibleStep2: true,
                    modalVisibleStep3: false,
                    modalSuccessVisible: false,
                    sendState: '',
                    payloadForgotPass: {
                        ...this.state.payloadForgotPass,
                        "register": this.state.payloadForgotPass.register,
                        "registerType": "nik",
                        "email": this.state.payloadForgotPass.email,
                        "verificationCode": ""
                    }
                })
            }, 500);
        } else {
            this.statusSendState()
            checkResponseError(res)
        }
    }

    handleNextStep = async (payload) => {
        this.statusSendState('loading')
        payload = {
            ...payload,
            verificationCode: Number(this.state.otp)
        }
        let res = await API.create("API_USER_RESET").postPassVerify(payload);
        if (res.ok && res.data.status === "S") {
            this.statusSendState('finished')
            setTimeout(() => {
                this.setState({
                    modalVisible: false,
                    modalVisibleStep2: false,
                    modalVisibleStep3: true,
                    modalSuccessVisible: false,
                    sendState: '',
                    otp: '',
                    payloadForgotPass: {
                        ...this.state.payloadForgotPass,
                        "register": this.state.payloadForgotPass.register,
                        "registerType": "nik",
                        "companyGroupId": this.state.payloadForgotPass.companyGroupId,
                        "csrf": res.data.data.csrf
                    }
                })
            }, 500);
        } else {
            this.statusSendState()
            this.setState({ otp: '' })
            checkResponseError(res)
        }
    }

    handleFinish = async (payload) => {
        if (!payload.password.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,})$/)) return this.setState({ errMsg: true })
        if (this.state.errMsg) this.setState({ errMsg: false })
        if (payload.password !== this.state.confirmPasswordValue) return alert('Please make sure your password match')
        payload = {
            ...payload,
            password: CryptoJS.MD5(payload.password).toString()
        }
        this.statusSendState('loading')
        let res = await API.create("API_USER_RESET").postPassFinal(payload);
        if (res.ok && res.data.status === "S") {
            this.statusSendState('finished')
            setTimeout(() => {
                if (this.state.forceCP) {
                    let routes = "/home";
                    this.setState({ redirect: true, routes });
                } else {
                    this.setState({
                        modalVisible: false,
                        modalVisibleStep2: false,
                        modalVisibleStep3: false,
                        modalSuccessVisible: true,
                        typeNewPass: false,
                        typeRePass: false,
                        sendState: '',
                        payloadForgotPass: defaultPayloadForgotPass,
                        username: '',
                        password: '',
                        companyGroupId: ''
                    })
                }
            }, 500);
        } else {
            this.statusSendState()
            checkResponseError(res)
        }
    }

    handleChangeUsername(event) {
        this.setState({ username: event.target.value })
    }

    handleChangePassword(event) {
        this.setState({ password: event.target.value })
    }

    handleChangeCompanyGroup(event) {
        this.setState({ companyGroupId: event.target.value.toUpperCase() })
    }

    handleSubmit(event) {
        event.preventDefault()
        this.login()
    }

    componentWillReceiveProps(newProps) {
        if (!newProps.auth.fetching) {
            if (newProps.auth && !newProps.auth.error && newProps.auth.user) {
                this.onFinishFetch();
                let passwordExpired = newProps.auth.user.passwordExpired;
                // console.log("-------PWD---"+passwordExpired);
                if (passwordExpired === 1) {
                    // this.showModalChangePassword();
                    const { username, companyGroupId } = this.state
                    this.setState({
                        payloadForgotPass: {
                            ...this.state.payloadForgotPass,
                            register: username,
                            companyGroupId,
                        },
                        forceCP: true,
                        modalVisible: true
                    })
                } else {
                    let routes = newProps.auth.user.userMCP ? "/ess-password" : "/home"
                    this.setState({ redirect: true, routes });
                }
            } else {
                this.onFinishFetch()
            }
        }
    }

    componentDidMount() {
        if (!R.isNil(this.props.auth.user) && this.props.auth.user.passwordExpired === 1) {
            this.forceLogout()
            let routes = "/home"
            this.setState({ redirect: true, routes, username: '', password: '', companyGroupId: '', forceCP: false });
        }
        const isForcedLogout = localStorage.getItem('isForcedLogout')
        if(isForcedLogout){
            localStorage.removeItem("isForcedLogout")
            alert("Sesi Anda Telah Berakhir. Silahkan Login Kembali.")
        }
    }

    login() {
        this.startFetch()
        const { username, password } = this.state
        let payload = {
            username: username,
            password: password
        }
        this.props.authRequest(payload);
    }

    startFetch = () => {
        this.LoadingBar.continousStart()
    }

    onFinishFetch = () => {
        if (typeof this.LoadingBar === "object") this.LoadingBar.complete()
    }

    renderErrorMsg() {
        return (
            <div className="txt-site txt-11 txt-main txt-bold txt-red margin-5px">
                <h4>Password must contain at least 8 characters, inlcuding UPPER/lowercase, symbol (@$!%*?&) and number</h4>
            </div>
        )
    }

    render() {

        if (this.state.redirect) {
            return <Redirect push to={this.state.routes} />
        }

        return (
            <HashRouter history={Router.browserHistory}>
                <Modal show={this.state.modalSuccessVisible}
                    handleClose={() => this.setState({ modalSuccessVisible: false })}
                    text="Reset Password Successfuly !"
                    subText="Your password has been reset.">
                </Modal>
                <Modal show={this.state.modalVisible} handleClose={this.hideModal} text={`${this.state.forceCP ? 'Change' : 'Forgot'} Password`} subText={'Please enter your email to change password'}>
                    <form action="#"
                        onSubmit={(e) => {
                            e.preventDefault()
                            this.handleReset(this.state.payloadForgotPass)
                        }}>
                        <FlexView vAlignContent="center" style={{ marginTop: 15, marginBottom: 15 }} grow={2}>
                            <FlexView hAlignContent="left" vAlignContent="center" className="margin-bottom-5px txt-site txt-15 txt-main txt-bold" style={{ width: '25%' }}>
                                Username
                            </FlexView>
                            <FlexView style={{ width: '75%' }}>
                                <input
                                    type="username"
                                    className="txt txt-sekunder-color"
                                    value={this.state.payloadForgotPass.register}
                                    onChange={this.setUsername.bind(this)}
                                    required />
                            </FlexView>
                        </FlexView>
                        <FlexView vAlignContent="center" style={{ marginTop: 15, marginBottom: 15 }} grow={2}>
                            <FlexView hAlignContent="left" vAlignContent="center" className="margin-bottom-5px txt-site txt-15 txt-main txt-bold" style={{ width: '25%' }}>
                                Email
                            </FlexView>
                            <FlexView style={{ width: '75%' }}>
                                <input
                                    type="email"
                                    className="txt txt-sekunder-color"
                                    placeholder={"name@domain.com"}
                                    value={this.state.payloadForgotPass.email}
                                    onChange={this.setEmail.bind(this)}
                                    required />
                            </FlexView>
                        </FlexView>
                        {/* <FlexView vAlignContent="center" style={{ marginTop: 15, marginBottom: 15 }} grow={2}>
                            <FlexView hAlignContent="left" vAlignContent="center" className="margin-bottom-5px txt-site txt-15 txt-main txt-bold" style={{ width: '25%' }}>
                                Company Group Code
                            </FlexView>
                            <FlexView style={{ width: '75%' }}>
                                <input
                                    type="text"
                                    className="txt txt-sekunder-color"
                                    value={this.state.payloadForgotPass.companyGroupId}
                                    onChange={this.setGroupID.bind(this)}
                                    required />
                            </FlexView>
                        </FlexView> */}

                        <FlexView hAlignContent="right">
                            <Button
                                type={'submit'}
                                state={this.state.sendState}
                                className="btn btn-width-full btn-red"
                            >
                                <span>RESET PASSWORD</span>
                            </Button>
                        </FlexView>

                    </form>
                </Modal>
                <Modal show={this.state.modalVisibleStep2} handleClose={this.hideModalStep2} text={`${this.state.forceCP ? 'Change' : 'Forgot'} Password`} subText={`Verification code has been sent by email to ${this.state.payloadForgotPass.email}`}>
                    <form action="#"
                        onSubmit={(e) => {
                            e.preventDefault()
                            this.handleNextStep(this.state.payloadForgotPass)
                        }}>
                        <div style={{ textAlign: "center", marginTop: 20 }}><div className='txt-site c-n-title txt-18 txt-bold txt-main padding-top-5px margin-bottom-5px'>Please enter the Verification Code !</div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <OtpInput
                                value={this.state.otp}
                                isInputNum={true}
                                onChange={
                                    (e) => this.setState({
                                        otp: e
                                    })
                                }
                                containerStyle={{ justifyContent: 'center' }}
                                inputStyle={{
                                    width: '3rem',
                                    height: '3rem',
                                    margin: '20px 1rem',
                                    fontSize: '1rem',
                                    borderRadius: 4,
                                    border: '2px solid rgba(0,0,0,0.3)'
                                }}
                                numInputs={4}
                                separator={<span>-</span>}
                            />
                        </div>
                        <div className="txt-site c-n-title txt-12 txt-main-color padding-top-5px margin-bottom-5px txt-primary" style={{ textAlign: "center" }}>
                            Please wait within 30 seconds for resend.
                        </div>
                        <div style={{ display: 'flex', justifyContent: "center" }}>
                            {this.state.modalVisibleStep2 && <OtpTimer seconds={30} minutes={0} buttonColor={'#004c97'} background={'transparent'} style={{ cursor: "pointer" }} textColor={'#888888'} resend={() => this._handleResend(this.state.payloadForgotPass)} />}
                        </div>
                        <FlexView hAlignContent="right">
                            <Button
                                type={'submit'}
                                state={this.state.sendState}
                                className="btn btn-width-full btn-red"
                            >
                                <span>NEXT</span>
                            </Button>
                        </FlexView>

                    </form>
                </Modal>
                <Modal show={this.state.modalVisibleStep3} handleClose={this.hideModalStep3} text={`${this.state.forceCP ? 'Change' : 'Forgot'} Password`}>
                    <form action="#"
                        onSubmit={(e) => {
                            e.preventDefault()
                            this.handleFinish(this.state.payloadForgotPass)
                        }}>
                        <FlexView vAlignContent="center">
                            <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                                <div className="column-1">
                                    <SimpleInput
                                        name="username"
                                        label={'Username'}
                                        value={this.state.payloadForgotPass.register}
                                        readOnly={true}
                                    />
                                    <div className="card-date-picker">
                                        <div className="margin-5px">
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>
                                                    Password <span style={{ color: "red" }}>*</span>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="double margin-bottom-20px">
                                            <input
                                                style={{ padding: 15 }}
                                                type={this.state.typeNewPass ? "text" : "password"}
                                                className="input"
                                                required
                                                placeholder="password"
                                                value={this.state.payloadForgotPass.password}
                                                onChange={this.setPassword.bind(this)}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-grey border-left btn-no-radius"
                                                onClick={this.showPassword.bind(this, "new")}
                                            >
                                                <i className={this.state.typeNewPass ? "fa fa-lg fa-eye" : "fa fa-lg fa-eye-slash"}
                                                />
                                            </button>
                                        </div>
                                        {this.state.errMsg && this.renderErrorMsg()}
                                    </div>
                                </div>
                                <div className="column-2">
                                    <div style={{ marginBottom: 86 }} />
                                    <div className="card-date-picker">
                                        <div className="margin-5px">
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>
                                                    Confirm Password <span style={{ color: "red" }}>*</span>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="double margin-bottom-20px">
                                            <input
                                                style={{ padding: 15 }}
                                                type={this.state.typeRePass ? "text" : "password"}
                                                className="input"
                                                required
                                                placeholder="password"
                                                value={this.state.confirmPasswordValue}
                                                onChange={this.setConfirmPassword.bind(this)}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-grey border-left btn-no-radius"
                                                onClick={this.showPassword.bind(this, "confirm")}
                                            >
                                                <i className={this.state.typeRePass ? "fa fa-lg fa-eye" : "fa fa-lg fa-eye-slash"}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FlexView>
                        <div className='padding-15px'>
                            <span className='txt-site c-n-title txt-12 txt-main padding-top-5px margin-bottom-5px'>For a strong password, please use a hard to guess combination of text with upper and lower case characters, symbol and numbers.</span>
                        </div>

                        <FlexView hAlignContent="right">
                            <Button
                                type={'submit'}
                                state={this.state.sendState}
                                className="btn btn-width-full btn-red"
                            >
                                <span>FINISH</span>
                            </Button>
                        </FlexView>

                    </form>
                </Modal>
                {/* fchangepassword */}
                <Modal show={this.state.forcedChangePassword.modalVisible}
                    handleClose={this.hideModalChangePassword}
                    text={"Change Password"}
                    subText="You have been flagged to change password. Please enter your new password">
                    <form action="#"
                        onSubmit={(e) => {
                            e.preventDefault()
                            this.handleFinishChangePassword(this.state.forcedChangePassword.payload)
                        }}>
                        <FlexView vAlignContent="center">
                            <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
                                <div className="column-1">
                                    {/* <SimpleInput
                                            name="oldPassword"
                                            label={'oldPassword'}
                                            value={this.state.forcedChangePassword.payload.oldPassword}
                                            readOnly={true}
                                        /> */}
                                    <div className="card-date-picker">
                                        <div className="margin-5px">
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>
                                                    Password <span style={{ color: "red" }}>*</span>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="double margin-bottom-20px">
                                            <input
                                                style={{ padding: 15 }}
                                                type={this.state.typeNewPass ? "text" : "password"}
                                                className="input"
                                                required
                                                placeholder="password"
                                                value={this.state.forcedChangePassword.payload.newPassword}
                                                onChange={e =>
                                                    this.setState({
                                                        forcedChangePassword: {
                                                            ...this.state.forcedChangePassword,
                                                            payload: {
                                                                ...this.state.forcedChangePassword.payload,
                                                                newPassword: e.target.value
                                                            }
                                                        }
                                                    })
                                                }
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-grey border-left btn-no-radius"
                                                onClick={this.showPassword.bind(this, "new")}
                                            >
                                                <i className={this.state.typeNewPass ? "fa fa-lg fa-eye" : "fa fa-lg fa-eye-slash"}
                                                />
                                            </button>
                                        </div>
                                        {this.state.errMsg && this.renderErrorMsg()}
                                    </div>
                                </div>
                                <div className="column-2">
                                    {/* <div style={{marginBottom: 86}}/> */}
                                    <div className="card-date-picker">
                                        <div className="margin-5px">
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>
                                                    Confirm Password <span style={{ color: "red" }}>*</span>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="double margin-bottom-20px">
                                            <input
                                                style={{ padding: 15 }}
                                                type={this.state.typeRePass ? "text" : "password"}
                                                className="input"
                                                required
                                                placeholder="password"
                                                value={this.state.forcedChangePassword.payload.confirmNewPassword}
                                                onChange={e =>
                                                    this.setState({
                                                        forcedChangePassword: {
                                                            ...this.state.forcedChangePassword,
                                                            payload: {
                                                                ...this.state.forcedChangePassword.payload,
                                                                confirmNewPassword: e.target.value
                                                            }
                                                        }
                                                    })
                                                }
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-grey border-left btn-no-radius"
                                                onClick={this.showPassword.bind(this, "confirm")}
                                            >
                                                <i className={this.state.typeRePass ? "fa fa-lg fa-eye" : "fa fa-lg fa-eye-slash"}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FlexView>
                        <div className='padding-15px'>
                            <span className='txt-site c-n-title txt-12 txt-main padding-top-5px margin-bottom-5px'>For a strong password, please use a hard to guess combination of text with upper and lower case characters, symbol and numbers.</span>
                        </div>

                        <FlexView hAlignContent="right">
                            <Button
                                type={'submit'}
                                state={this.state.sendState}
                                className="btn btn-width-full btn-red"
                            >
                                <span>FINISH</span>
                            </Button>
                        </FlexView>

                    </form>
                </Modal>

                <div className="main-content" >
                    <LoadingBar onRef={ref => (this.LoadingBar = ref)} />
                    <div
                        className="app-login" style={{
                            backgroundImage: 'url(' + cover + ')',
                            backgroundSize: "cover",
                        }}>

                        <div className="grid grid-5x" style={{ paddingTop: "100px" }}>
                            <div className="column-4">
                                <div className="login-content display-flex-normal" style={{ height: '450px', width: "450px", borderRadius: 20, boxShadow: "5px 5px 5px #7B7A72" }}>
                                    {/* <div className="width width-450px">
                                <div
                                    className="image image-all background-dark-grey"
                                    style={{
                                        backgroundImage: 'url(' + cover + ')'
                                    }}/>
                            </div> */}

                                    <div className="width width-full display-flex-column">

                                        {/* top */}
                                        <div className="padding-15px display-flex-normal">
                                            {/* <div className="width width-100px">
                    <div className="image image-circle image-50px border-all">
                      <img src={logo} alt=""></img>
                    </div>
                </div> */}
                                            <div className="width width-full content-left">
                                                {/* <p className="txt-site txt-primary txt-12" style={{fontStyle:'italic'}}>Human Capital Information System</p> */}
                                            </div>

                                            {/* <div className="width width-full content-right"> */}
                                            {/* <h1 className="txt-site txt-main txt-20">PROHACE</h1> */}
                                            {/* <img src={Logo} width={"60%"} alt="" />
                                            </div> */}
                                        </div>

                                        {/* middle */}
                                        <form onSubmit={this.handleSubmit}>
                                            <div className="width width-center width-350px">

                                                {/* <div className="padding-25px"></div> */}

                                                <div className="margin-15px">
                                                    <h1 className="txt-site txt-center txt-red txt-20">Welcome Back!</h1>
                                                </div>

                                                {/* <div className="padding-5px" /> */}

                                                <div className="margin-15px">
                                                    <div className="margin-bottom-5px txt-site txt-10 txt-main txt-bold">
                                                        Username
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="txt txt-sekunder-color"
                                                        value={this.state.username}
                                                        onChange={this.handleChangeUsername}
                                                        required />
                                                </div>

                                                {/* <div className="margin-15px">
                      <div className="margin-bottom-5px txt-site txt-10 txt-main txt-bold">
                        Password
                      </div>
                      <input 
                        type="password" 
                        className="txt txt-sekunder-color"
                        value={this.state.password}
                        onChange={this.handleChangePassword}
                        required></input>
                    </div> */}
                                                <div className="card-date-picker">
                                                    <div className="margin-5px">
                                                        <div className="txt-site txt-11 txt-main txt-bold">
                                                            <h4>
                                                                Password
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <div className="double margin-bottom-20px">
                                                        <input
                                                            style={{ padding: 15 }}
                                                            type={this.state.typePass ? "text" : "password"}
                                                            className="txt txt-sekunder-color"
                                                            value={this.state.password}
                                                            required
                                                            onChange={this.handleChangePassword}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-grey border-left btn-no-radius"
                                                            onClick={() => this.setState({ typePass: !this.state.typePass })}
                                                        >
                                                            <i className={this.state.typePass ? "fa fa-lg fa-eye" : "fa fa-lg fa-eye-slash"}
                                                            />
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* <div className="margin-15px">
                                                    <div className="margin-bottom-5px txt-site txt-10 txt-main txt-bold">
                                                        Company Group Code
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="txt txt-sekunder-color"
                                                        value={this.state.companyGroupId}
                                                        onChange={this.handleChangeCompanyGroup}
                                                    />
                                                </div> */}

                                                <div className="margin-15px display-flex-normal">
                                                    <input
                                                        type="submit"
                                                        value="SIGN IN"
                                                        className="btn btn-width-full btn-red" />
                                                    <div className="width width-full content-right">
                                                        <i className="fa fa-1x fa-key txt-site txt-primary txt-9 margin-right-5px" />
                                                        <span onClick={this.showModal.bind(this)}
                                                            className="txt-site txt-red txt-bold txt-10"
                                                            style={{ cursor: 'pointer' }}>Forgot Password?</span>
                                                    </div>
                                                </div>

                                                {/* <div className="padding-25px"></div> */}

                                            </div>
                                        </form>

                                        {/* bottom */}
                                        <div className="padding-15px display-flex-normal">
                                            {/* <div className="width width-full display-flex-normal">
                                        <div className="txt-site txt-10 txt-primary margin-right-5px">
                                            Available on
                                        </div>
                                        <div className="txt-site txt-10 txt-primary margin-right-5px">
                      <i className="fab fa-lw fa-apple" /> iOS
                    </div>
                                        <div className="txt-site txt-10 txt-primary">
                                            <i className="fab fa-lw fa-android"/> Android
                                        </div>
                                    </div> */}

                                            {/* <div className="width width-full">
                                        <div className="content-right">
                                            <div className="txt-site txt-10 txt-primary">
                                                <span className="margin-right-5px">Supported Browser</span>
                                                <i className="fab fa-1x fa-chrome margin-right-5px"/>
                                                <i className="fab fa-1x fa-safari margin-right-5px"/>
                                                <i className="fab fa-1x fa-firefox margin-right-5px"/>
                                                <i className="fab fa-1x fa-edge margin-right-5px"/>
                                                <i className="fab fa-1x fa-internet-explorer"/>
                                            </div>
                                        </div>
                                    </div> */}

                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </HashRouter>
        )
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth
    };
};

const mapDispatchToProps = dispatch => {
    return {
        authRequest: obj => dispatch(AuthAction.authRequest(obj)),
        authLogout: () => dispatch(AuthAction.authLogout()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);